import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.788 3.946c.449-1.078 1.976-1.078 2.424 0l2.082 5.006 5.404.433c1.164.093 1.636 1.546.75 2.305l-4.118 3.527 1.258 5.274c.27 1.135-.965 2.033-1.961 1.424L12 19.09l-4.626 2.826c-.997.609-2.232-.289-1.961-1.424l1.258-5.274-4.118-3.527c-.886-.76-.414-2.212.75-2.305l5.403-.433zM12 4.938v12.619c.237 0 .474.064.684.192l4.34 2.651-1.18-4.946c-.114-.48.05-.982.423-1.302l3.862-3.308-5.069-.406c-.49-.04-.918-.35-1.107-.804z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(SvgComponent);
export const StarHalfIcon = ForwardRef;